'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getClassName = {};

exports.__exports = getClassName;
